module.exports = __webpack_public_path__ + "0770fae98153e76ac61d2f2724c6a15c.png";